
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strumenti-servizi/tecniche-stampa",
      function () {
        return require("private-next-pages/strumenti-servizi/tecniche-stampa/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strumenti-servizi/tecniche-stampa"])
      });
    }
  